import { render, staticRenderFns } from "./BotaoContratoRastreabilidadeAprovador.vue?vue&type=template&id=95fc5d94&lang=pug"
import script from "./BotaoContratoRastreabilidadeAprovador.vue?vue&type=script&lang=js"
export * from "./BotaoContratoRastreabilidadeAprovador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports